import * as React from "react";

import World from "../../world";
import Gallery from "../../types/Gallery";
import View from "./View";
import { CoHost } from "../../api";

export interface Props {
    gallery_name: string;
    world: World;
}

export interface State {
    gallery: Gallery;
    cohosts: Array<CoHost> | null;
}

export default class CoHostsController extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        props.world.listCoHosts(props.gallery_name)
            .then((cohosts) => {
                this.setState({
                    cohosts,
                });
            });

        const gallery = props.world.galleries[props.gallery_name];

        this.state = {
            gallery,
            cohosts: null,
        };
        if (gallery) {
            return;
        }

        props.world.getGallery(props.gallery_name)
            .then((resp) => {
                if (resp[1]) {
                    throw resp[1];
                }
                const gallery = props.world.galleries[props.gallery_name];

                this.setState({
                    gallery,
                });
            })
            .catch((err: Error) => {
                // TODO error page
                console.log(err);
            });
    }

    render() {
        if (!this.state.gallery || !this.state.cohosts) {
            // TODO spinner
            return null;
        }

        return (
            <View world={this.props.world} gallery={this.state.gallery} cohosts={this.state.cohosts} />
        );
    }
}
